import { useState, useEffect } from 'react';
import { Grid, Button } from '@mui/material';
// import { ReactComponent as JobPaymentBanner } from '../../../assets/images/payment-banner.svg';
import EastIcon from '@mui/icons-material/East';
// import '../../pages/employer/employerStyle.scss'
import "./AccountSuspendedModal.scss";
import { useNavigate } from "react-router-dom";

import _ from 'lodash';
import Loader from '../Loader';
import { PaymentValidate } from '../../sevices/job';
import { ENV_CONFIG } from '../../constant';
import { GetEmployeeProfile, rejectionPaymentCapture } from '../../sevices/account';


// SUBSCRIPTION REJECTION FUNCTION 
function RejectionPaymentComponent() {
    const [loading, setLoading] = useState(false);

    const [employeeProfile, setEmployeeProfile] = useState('');
    const [orderID, setOrderID] = useState('');

    const navigate = useNavigate();
    // PAYMENT VALIDATION FUNCTION 
    const PaymentForm = (orderId) => {
        setLoading(true)
        try {
            const options = {
                key: ENV_CONFIG.RAZORPAY_KEY,
                amount: parseInt(employeeProfile?.rejection_payment_order_object?.amount),
                currency: 'INR',
                name: 'Job rejection payment',
                description: 'Payment to job rejection',
                order_id: orderId,
                handler: async (response) => {
                    const body = {
                        "order_id": response?.razorpay_order_id,
                    }
                    const res = await rejectionPaymentCapture(body);

                    if (res?.status === 200) {
                        setLoading(false);
                        navigate("/explorejobs?roles=employee");
                    } else {
                        setLoading(false);
                    }
                },
                notes: {
                },
                theme: {
                    color: '#528FF0'
                }
            };

            const razorpayInstance = new window.Razorpay(options);
            razorpayInstance.open();
        } catch (error) {
            setLoading(false)
        } finally {
            setLoading(false)
        }
        // };

    };

    const fetchProfileData = async () => {
        console.log("testing...");

        setLoading(true)
        try {
            const employee = await GetEmployeeProfile();
            console.log("employeedetails", employee);

            if (employee) {
                setEmployeeProfile(employee?.data?.details);
                setOrderID(employee?.data?.details?.rejection_payment_order_object?.id);
                setLoading(false)
            }
        } catch (error) {
            console.log("employeedetailserror", error);
            setLoading(false)
        }




    }
    // PAYMENT API FUNCTION    
    const Onsubmit = async () => {
        setLoading(true);
        try {
            if (orderID) {
                setLoading(false)
                 PaymentForm(orderID)
            }
        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchProfileData();
    }, []);




    return (
        <div className="dashboardPageContainer"
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                backgroundColor: '#f5f5f5',
            }}>
            <Grid container alignItems="center" justifyContent="center" spacing={0}>
                <Grid item xs={12} sm={5}>
                    <div className="jobPaymentContainerRejection">

                        <div className="jobPaymentCard">
                            <div className="jobPaymentCardRight" style={{ width: '100%' }}>
                                <div className="qualificationSetContainer" style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                                    <div className="qualificationSet" style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
                                        <span className="CardMainTitle">Account Suspended</span>
                                        <span style={{ fontSize: 15, lineHeight: '23px', color: '#000000' }}>1. Please consider your commitments carefully before accepting job offers.</span>
                                        <span style={{ fontSize: 15, lineHeight: '23px', color: '#000000' }}>2. Repeatedly declining confirmed job assignments (3 times) may lead to account suspension.</span>
                                        <span style={{ fontSize: 15, lineHeight: '23px', color: '#000000' }}>3. To reactivate your account after suspension, a fee of Rs.25 will be applicable.</span>
                                    </div>
                                </div>
                                <Button onClick={() => { Onsubmit() }} variant="contained" className="JobPayNowBtn">
                                    <span>Pay ₹{"25"} to Activate your account</span>
                                    <EastIcon />
                                </Button>
                            </div>
                        </div>

                    </div>
                </Grid>
            </Grid>
            <Loader loading={loading} />
        </div>
    );
}

export default RejectionPaymentComponent;